/**
 * The header naming this console's own origin. The server uses it ONLY to
 * derive the console's public origin when no setting, env value or configured
 * public origin names one, and only after matching its host against the
 * request's own host (api/internal/httpapi/tenant_init_config.go). Sent on
 * every request that needs the tenant-init planner — the wizard's config,
 * plan, nonce and start, the access status and the module list — so they all
 * resolve the same way.
 */
export const CONSOLE_ORIGIN_HEADER = "X-Console-Origin";

export function withConsoleOrigin(): { headers: Record<string, string> } {
  const origin = typeof window === "undefined" ? "" : window.location.origin;
  return { headers: origin ? { [CONSOLE_ORIGIN_HEADER]: origin } : {} };
}
